
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.375 14.57v-4.145a7.786 7.786 0 00-1.863-5.042 7.889 7.889 0 00-4.7-2.66v-1.42c0-.345-.138-.677-.384-.921a1.317 1.317 0 00-1.856 0 1.299 1.299 0 00-.384.921v1.42a7.888 7.888 0 00-4.7 2.66 7.786 7.786 0 00-1.863 5.042v4.145a3.935 3.935 0 00-1.9 1.424A3.89 3.89 0 000 18.244v2.607c0 .346.138.677.384.922.247.244.58.381.929.381h4.12a5.211 5.211 0 001.878 2.774 5.275 5.275 0 006.378 0 5.21 5.21 0 001.877-2.774h4.121c.349 0 .682-.137.929-.381.246-.245.384-.576.384-.922v-2.606a3.891 3.891 0 00-.726-2.251 3.936 3.936 0 00-1.899-1.424zM5.25 10.425c0-1.382.553-2.708 1.538-3.685A5.269 5.269 0 0110.5 5.213a5.27 5.27 0 013.712 1.527 5.194 5.194 0 011.538 3.685v3.91H5.25v-3.91zm5.25 13.032a2.64 2.64 0 01-1.304-.353 2.616 2.616 0 01-.954-.95h4.515a2.615 2.615 0 01-.954.95 2.64 2.64 0 01-1.303.354zm7.875-3.91H2.625v-1.302c0-.346.138-.677.384-.922.247-.244.58-.381.929-.381h13.124c.349 0 .682.137.929.381.246.245.384.576.384.922v1.303z"}})])
          )
        }
      }
    